var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FloatingOverlay } from '@floating-ui/react';
import { overlayStyle } from './styles';
function Overlay(_a) {
    var { isVisible } = _a, restProps = __rest(_a, ["isVisible"]);
    return (_jsx(FloatingOverlay, Object.assign({ lockScroll: true }, restProps, { css: overlayStyle({ isVisible }) })));
}
export default Overlay;
